module.exports = __webpack_public_path__ + "static/media/barberscape-replacement-blade-4.ebc20669.png";